export * from './types.js'
export { BADGE_SHAPES } from './shapes.js'
export { BADGE_PALETTES, ICE_ENAMEL } from './palettes.js'
export { BADGE_TIER_STYLES, tierOf } from './tiers.js'
export type { TierInput } from './tiers.js'
export { BADGE_ICON_KEYS, BADGE_ICONS, customIconMarkup } from './icons.js'
export { badgeNumeralSpec, renderBadgeMasks, renderBadgeSvg } from './render.js'
export type { BadgeArtMasks } from './render.js'
export {
    BADGE_ART_CSS_COLORS,
    BADGE_ART_DARK_COLORS,
    BADGE_ART_LIGHT_COLORS,
    BADGE_ASPECT,
} from './colors.js'
export { badgeArtVersion } from './version.js'
export { BADGE_COMPANIES, COMPANY_ANNIVERSARY_PALETTE, isBadgeCompany } from './company.js'
export type { BadgeCompany } from './company.js'
export { isBadgePaletteKey, isBadgeShapeKey, resolveBadgeArt } from './spec.js'
export type { BadgeArtInput } from './spec.js'
